// Shared ref so Navbar can trigger the tour without a circular App → Navbar → App import
export const startTourFn = { current: null };
